import LoginModal from './LoginModal.jsx';
import RegisterModal from './RegisterModal.jsx';
import ForgotPasswordModal from './ForgotPasswordModal.jsx';
import ResetPasswordModal from './ResetPasswordModal.jsx';
import VerifyEmailModal from './VerifyEmailModal.jsx';

/**
 * Контейнер модалки аутентификации (ЧТЗ-AUTH-004, FR-AUTH-20).
 * Один оверлей, режим выбирается через `mode`:
 *   'login' | 'register' | 'forgot' | 'reset'
 *
 * props:
 *   auth        — общий инстанс useAuth() (из App)
 *   mode        — текущий режим
 *   onSwitchMode(mode) — сменить режим (сбрасывает поля/ошибки, т.к. компоненты ремаунтятся по key)
 *   resetToken  — токен сброса (для режима 'reset')
 *   verifyToken — токен подтверждения email (для режима 'verify', BUG-AUTH-01)
 *   onClose()   — закрыть всю модалку
 *   showToast(notice)
 */
export default function AuthModal({ auth, mode, onSwitchMode, resetToken, verifyToken, onClose, showToast }) {
  const notify = (type, msg) => showToast?.({ type, msg });

  const handleLogin = async (email, password) => {
    await auth.login(email, password);
    notify('success', 'Вход выполнен');
    onClose?.();
  };

  const handleRegister = async (payload) => {
    await auth.register(payload);
  };

  const handleForgot = async (email) => {
    await auth.forgotPassword(email);
  };

  const handleReset = async (token, newPassword) => {
    await auth.resetPassword(token, newPassword);
    notify('success', 'Пароль изменён, войдите с новым паролем');
  };

  const handleVerify = async (token) => {
    await auth.verifyEmail(token);
  };

  return (
    <div
      className="acc-overlay"
      onMouseDown={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
    >
      {mode === 'login' && (
        <LoginModal
          key="login"
          onLogin={handleLogin}
          onClose={onClose}
          onSwitchMode={onSwitchMode}
        />
      )}
      {mode === 'register' && (
        <RegisterModal
          key="register"
          onRegister={handleRegister}
          onClose={onClose}
          onSwitchMode={onSwitchMode}
        />
      )}
      {mode === 'forgot' && (
        <ForgotPasswordModal
          key="forgot"
          onForgot={handleForgot}
          onClose={onClose}
          onSwitchMode={onSwitchMode}
        />
      )}
      {mode === 'reset' && (
        <ResetPasswordModal
          key="reset"
          token={resetToken}
          onReset={handleReset}
          onClose={onClose}
          onSwitchMode={onSwitchMode}
        />
      )}
      {mode === 'verify' && (
        <VerifyEmailModal
          key="verify"
          token={verifyToken}
          onVerify={handleVerify}
          onClose={onClose}
          onSwitchMode={onSwitchMode}
        />
      )}
    </div>
  );
}
